import {
  LabelRelease,
  LabelV2Release,
  Release,
  ReleaseType,
  SoundCloudRelease,
  TuneCoreRelease,
} from 'types/releases';
import {
  fetchReleaseEffect,
  fetchReleaseVersionEffect,
} from 'app/store/Releases/effects';
import { routes } from 'app/routing/routesConfig';
import { useAppDispatch } from 'app/store';
import { useNavigate, useParams } from 'react-router-dom';
import { useCallback, useState } from 'react';

export const useFetchRelease = (release?: Release) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { guid, versionGuid } = useParams();
  const [loading, setLoading] = useState(true);

  const handleLabelVersionFetch = async (release: LabelRelease) => {
    const song = Object.values((release && release.songs) || {}).find((song) =>
      song.versions.find((version) => version.guid === versionGuid)
    );
    try {
      if (!song?.songGuid) {
        throw new Error('song not found in release');
      }
      await dispatch(
        fetchReleaseVersionEffect({
          songGuid: song.songGuid,
          versionGuid: versionGuid as string,
        })
      ).unwrap();
    } catch (e) {
      navigate(routes.release.path.replace(':guid', release.guid));
    }
  };

  const handleVersionFetch = async (
    release: SoundCloudRelease | TuneCoreRelease | LabelV2Release
  ) => {
    try {
      await dispatch(
        fetchReleaseVersionEffect({
          releaseGuid: release.guid,
          versionGuid: versionGuid as string,
        })
      ).unwrap();
    } catch (e) {
      navigate(routes.release.path.replace(':guid', release.guid));
    }
  };

  const fetchReleaseVersion = async (type: ReleaseType) => {
    switch (type) {
      case ReleaseType.LABEL:
        await handleLabelVersionFetch(release as LabelRelease);
        break;
      case ReleaseType.SOUNDCLOUD:
        await handleVersionFetch(release as SoundCloudRelease);
        break;
      case ReleaseType.TUNECORE: {
        await handleVersionFetch(release as TuneCoreRelease);
        break;
      }
      case ReleaseType.LABEL_V2:
        await handleVersionFetch(release as LabelV2Release);
        break;
      default:
        // eslint-disable-next-line no-console
        console.error('No release type defined');
        break;
    }
    setLoading(false);
  };

  const fetchRelease = useCallback(async () => {
    try {
      if (!release?.guid) {
        await dispatch(fetchReleaseEffect({ guid: guid as string })).unwrap();
      }
      if (release?.guid) {
        fetchReleaseVersion(release.type);
      }
    } catch (e) {
      navigate(routes.releases.path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guid, release?.guid]);

  return {
    loading,
    fetchRelease,
  };
};
